import { render } from "./DetailsLinkRenderer.vue?vue&type=template&id=8839a2a2&scoped=true"
import script from "./DetailsLinkRenderer.vue?vue&type=script&lang=js"
export * from "./DetailsLinkRenderer.vue?vue&type=script&lang=js"

import "./DetailsLinkRenderer.vue?vue&type=style&index=0&id=8839a2a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8839a2a2"]])

export default __exports__